import React, { PropTypes } from 'react';
import axios from './../../../../constants/axios';
import { Table } from 'react-bootstrap';
import className from 'classnames';
import './SaleInvoiceDetailItem.less';

class SaleInvoiceDetailItem extends React.Component {
   constructor(props) {
      super(props);
      this.state = {
         invoiceItems: [],
      };
   }

   componentDidMount() {
      const { invoiceId } = this.props.params;
      axios.get(`inventorySales/getInventoryItemsByInvoiceId/${invoiceId}`)
         .then((res) => {
            this.setState({
               invoiceItems: res.data
            });
         });
   }

   render() {
      const { invoiceItems } = this.state;
      return (
         <div className="SaleInvoiceDetailItem" >
            <div className="hideOnPrint" >
               <h4 >Invoice Items</h4 >
            </div >
            <Table >
               <thead >
               <tr >
                  <th >S.L</th >
                  <th >Item Name</th >
                  <th >Qty</th >
                  <th >Price</th >
                  <th >Dis</th >
                  <th className="onHandStock" >Dis P%</th >
                  <th >U.Total</th >
                  <th className="onHandStock" >On Hand</th >
               </tr >
               </thead >
               <tbody >
               {invoiceItems && invoiceItems.items && invoiceItems.items.map((item, index) => (
                  <tr key={item.id} className={className({
                     outOfStock: item.unit_on_hand < item.unit,
                  })} >
                     <td >{index + 1}</td >
                     <td >{item.name}</td >
                     <td >{item.unit}</td >
                     <td >{item.price}</td >
                     <td >{item.unit_discount}</td >
                     <td className="onHandStock" >{((item.unit_discount * 100) / item.price).toFixed(2)}</td >
                     <td >{item.unit_total}</td >
                     <td className="onHandStock" >{item.unit_on_hand}</td >
                  </tr >
               ))}
               <tr className="totalDisplay" >
                  <td colSpan="2" >ওজন: {invoiceItems.totalWeight} Kg,
                     Dis: ({invoiceItems.customerDiscountPercentage}%)
                     {invoiceItems.profitPercentage &&
                     <span >({invoiceItems.unitProfitTotal}-{invoiceItems.profitPercentage}p)</span >}
                  </td >
                  <td colSpan="2" >মোট:</td >
                  <td >{invoiceItems.unitDiscountTotal}</td >
                  <td >{invoiceItems.allTotalItemPrice}</td >
               </tr >
               </tbody >
            </Table >
         </div >
      );
   }
}

SaleInvoiceDetailItem
   .propTypes = {
   params: PropTypes.object
};

export default SaleInvoiceDetailItem;



/** WEBPACK FOOTER **
 ** ./src/components/InvoiceManagement/Sale/SaleInvoiceDetail/SaleInvoiceDetailItem.js
 **/